export const invoicesTransferTypes = {
  CLEAR_INVOICES: 'CLEAR_INVOICES',
  SET_INPUTS: 'SET_INPUTS',
  GET_INVOICES_TRANSFER: 'GET_INVOICES_TRANSFER',
  SELECT_INVOICE_ID: 'SELECT_INVOICE_ID',
  CANCEL_INVOICE_TRANSFER: 'CANCEL_INVOICE_TRANSFER',
  SET_FORM_CANCEL_INVOICE: 'SET_FORM_CANCEL_INVOICE',
  SET_EMAIL_INVOICE: 'SET_EMAIL_INVOICE',
};
